import { useState, useCallback, useMemo } from 'react';
import { Photo } from './photo';
import { NextIcon } from '../../icons/next';
import { PrevIcon } from '../../icons/prev';
import { initSwipe } from '../../../helpers/swipe';

export function Photos({ urls, width, height }) {
  let [index, setIndex] = useState(0);

  let next = useCallback((event) => {
    setIndex(x => x === urls.length - 1 ? 0 : x + 1);

    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }, []);

  let prev = useCallback((event) => {
    setIndex(x => x === 0 ? urls.length - 1 : x - 1);

    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }, []);

  let { lock, move } = useMemo(() => initSwipe({ forward: next, back: prev }), []);

  return (
    <div
      className={`property-card__photos`}
      onMouseDown={lock}
      onTouchStart={lock}
      onMouseUp={move}
      onTouchEnd={move}
    >
      <Photo url={urls[index]} width={width} height={height} />

      <div className={`property-card__control property-card__control_type_next`} onClick={next}><NextIcon /></div>
      <div className={`property-card__control property-card__control_type_prev`} onClick={prev}><PrevIcon /></div>
    </div>
  );
}
